var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"common-container"},[_c(_setup.SurfDetailHeaderAffix,[_c('h2',{staticClass:"surf-module-title"},[_vm._v(_vm._s(_vm.name))])]),_c(_setup.CRichText,{attrs:{"data":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }